import { ApiClientFactory } from "@/clients/ApiClientFactory";

let factory = new ApiClientFactory(process.env.VUE_APP_TENANT_BASE_URL, true, true);

/**
 *
 * @namespace LoginClient
 */
export const LoginClient = {
  /**
   * Logs a user in.
   * @param {Object} data
   * @param {string} data.username - The user's username, usually the email
   * @param {string} data.password - The user's password
   * @param {string} data.grant_type=password - The auth grant type
   * @param {number} data.client_id - The client id
   * @param {string} data.client_secret - The client secret
   * @param {?number} tenantId - The id of the tenant
   * @returns {Promise<AxiosResponse<Object>>}  The auth request promise
   *
   */
  login(data, tenantId) {
    /**
     * @property {string} response.data.access_token - the access token
     */
    return factory.post("oauth/token", data, tenantId !== null ? { "X-Tenant": tenantId } : {});
  },

  /**
   * Triggers a password reset
   * @function
   * @param {object} email
   * @param {?number} tenantId - The id of the tenant
   * @returns {Promise<AxiosResponse<Object>>} The user object
   */
  reset(email, tenantId) {
    return factory.post("/api/1/password/create", email, tenantId !== null ? { "X-Tenant": tenantId } : {});
  },
  /**
   *
   *
   * @param {Object} params
   * @param {string} params.password
   * @param {string} params.password_confirmation
   * @param {string} params.token
   * @param {?number} tenantId - The id of the tenant
   * @returns {Promise<AxiosResponse<*>>}
   */
  setNew(params, tenantId) {
    return factory.post("/api/1/password/reset", params, tenantId !== null ? { "X-Tenant": tenantId } : {});
  },
};
